import { IProduct } from "./product.types"

export class Product implements IProduct {
  constructor(
    public id: number,
    public code: string,
    public name: string,
    public displayName: string,
    public duration: number,
    public isActiveForEnrolment: boolean,
    public isActiveForRenewal: boolean,
    public isRecommendedForEnrolment: boolean,
    public isRecommendedForRenewal: boolean,
    public requiresSmartCharging: boolean,
  ) {}

  get isNscProduct() {
    return this.code.endsWith("NSC")
  }
}
